import RcsUtils from '../utils/RcsUtils';

class StrisciaBlogHP {
  render() {
    this.handlers();
  }

  handlers() {
    if (document.querySelector('.striscia_blog_2015') !== null) {
      this.init();
    }
  }

  init() {
    let altriElement = document.querySelector('.altri');
    let hideElement = document.querySelector('.nascondi');
    altriElement.addEventListener('click', e => {
      e.preventDefault();
      let hiddenBlock = Array.from(document.querySelectorAll('.blocco_nascosto'));
      altriElement.style.display = 'none';

      if (RcsUtils.getDevice() === 'mobile') {
        hiddenBlock.forEach(element => {
          element.style.display = 'table';
        });
      } else {
        let contentElement = document.querySelector('.content');
        contentElement.style.border = 'none';
        contentElement.style.borderBottom = '1px solid #dadbde';
        hiddenBlock.forEach(element => {
          element.style.display = 'block';
        });
      }

      hideElement.style.display = 'block';
    });

    hideElement.addEventListener('click', e => {
      e.preventDefault();
      let hiddenBlock = Array.from(document.querySelectorAll('.blocco_nascosto'));

      hiddenBlock.forEach(element => {
        element.style.display = 'none';
      });

      hideElement.style.display = 'none';
      altriElement.style.display = 'block';
    });
  }
}

module.exports = StrisciaBlogHP;



// WEBPACK FOOTER //
// ./src/rcs_cor_hp-lazy-loading/boxes/StrisciaBlogHP.js